<template>
  <div>
    <div class="modal-window mas030">
      <header class="modal-header">
        <div class="tit">{{ $i18nUtil.trans("title.LinkedOkr.001","OKR연결 추가") }}</div>
        <button @click="closePopup" class="btn_close">닫기</button>
      </header>

      <div class="modal-content">
        <div class="input-box tit">
          <input
            type="text"
            required
            maxlength="34"
            v-model="modalInfo.projectName"
            onfocus="this.blur()"
            readonly
          />
        </div>
        <div
          class="calendar_box_grp"
          v-if="modalInfo.startDate && modalInfo.endDate"
        >
          <div class="calendar_box">
            <datepicker
              format="yyyy.MM.dd"
              v-model="modalInfo.startDate"
              disabled
              :placeholder="$i18nUtil.trans('message.placeholder.startDate','시작일')"
            ></datepicker>
          </div>
          <span>~</span>
          <div class="calendar_box">
            <datepicker
              format="yyyy.MM.dd"
              v-model="modalInfo.endDate"
              disabled
              :placeholder="$i18nUtil.trans('message.placeholder.endDate','종료일')"
            ></datepicker>
          </div>
        </div>

        <div class="info-txt">{{ $i18nUtil.trans("message.LinkedOkr.001","과제와 연관된 OKR이 있다면 연결해주세요") }}</div>
        <div>
          <div class="dropdown ty2 relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">{{
                  $i18nUtil.getLanguage() !== 'ko' && currentQrt.qrtTopMsgEn != null ? currentQrt.qrtTopMsgEn : currentQrt.qrtTopMsg
                }}</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="scroll">
                  <div
                    class="dropdown-list-item"
                    v-for="(item, index) in qrtList"
                    :key="index"
                  >
                    <div class="tit">
                      <button
                        type="button"
                        @click="qrtChange(item.QRT_CD, $event)"
                        :class="{ active: item.QRT_CD == currentQrt.qrtCd }"
                      >
                        {{ $i18nUtil.getLanguage() !== 'ko' && item.QRT_TOP_MSG_EN != null ? item.QRT_TOP_MSG_EN : item.QRT_TOP_MSG }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <div class="dropdown ty2 relative okr_linked" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss': '' ">
            <v-menu offset-y
              :close-on-content-click="isShowLayer">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  {{
                    currentKr.OKR_TITLE == undefined
                      ? $i18nUtil.trans("message.LinkedOkr.002","OKR 연결 선택")
                      : currentKr.OKR_TITLE
                  }}</v-btn
                >
              </template>
              <div class="dropdown-list">
                <div class="scroll">
                  <!-- <div class="tit">{{ $i18nUtil.trans("message.LinkedOkr.014","나의 OKR") }}</div> -->
                  <div class="no-data" v-if="myForIndex == 0">
                    {{ $i18nUtil.trans("message.LinkedOkr.003","연결된 나의 OKR이 없습니다.") }}
                  </div>
                  <ul
                    v-else
                    v-for="(item, index) in myForIndex"
                    :key="'myFor' + index"
                  >
                    <li
                     disabled
                     @mouseover="isShowLayer = false"
                     @mouseout="isShowLayer = true" 
                    >
                      <button type="button" style="cursor: default">
                        {{ myOkrList[index].OKR_TITLE }}
                      </button>
                    </li>
                    <ul>
                      <li
                        :class="{ active: currentKr.OKR_ID == krItem.OKR_ID }"
                        v-for="(krItem, idx) in myKrList[index]"
                        :key="'kr' + idx"
                      >
                        <button type="button" @click="selectKr(krItem, $event)">
                          {{ krItem.OKR_TITLE }}
                        </button>
                      </li>
                    </ul>
                  </ul>


                  <!-- <div class="tit">{{  $i18nUtil.trans("message.LinkedOkr.004","나의 OKR과 연결된 상위 OKR")}}</div>
                  <div class="no-data" v-if="targetForIndex == 0">
                    {{ $i18nUtil.trans("message.LinkedOkr.005","연결된 상위 OKR이 없습니다.") }}
                  </div>
                  <ul
                    v-else
                    v-for="(item, index) in targetForIndex"
                    :key="'targetFor' + index"
                  >
                    <li
                      :class="{
                        active: currentKr.OKR_ID == targetOkrList[index].OKR_ID,
                      }"
                    >
                      <button
                        type="button"
                        @click="selectKr(targetOkrList[index], $event)"
                      >
                        <span class="ico-o"
                          >{{
                            ChangeOkrType(targetOkrList[index].OKR_TYPE)
                          }}
                          O</span
                        >
                        {{ targetOkrList[index].OKR_TITLE }}
                      </button>
                    </li>
                    <ul>
                      <li
                        :class="{ active: currentKr.OKR_ID == krItem.OKR_ID }"
                        v-for="(krItem, idx) in targetKrList[index]"
                        :key="'kr' + idx"
                      >
                        <button type="button" @click="selectKr(krItem, $event)">
                          <span class="ico-o"
                            >{{ ChangeOkrType(krItem.OKR_TYPE) }} KR</span
                          >
                          {{ krItem.OKR_TITLE }}
                        </button>
                      </li>
                    </ul>
                  </ul>-->
                </div> 


              </div>
            </v-menu>
          </div>
        </div>

        <ul class="ref">
          <li>{{ $i18nUtil.trans("message.LinkedOkr.006","* 나의 OKR과 연결된 상위 OKR을 선택할 수 있으며, 상위 OKR 연결 시 하위 연결 멤버들도 자동으로 과제가 연결됩니다.") }}</li>
          <li>{{ $i18nUtil.trans("message.LinkedOkr.007","* 운영자가 아닌, 과제 멤버도 OKR을 자유롭게 연결할 수 있습니다.") }}</li>
          <li>{{ $i18nUtil.trans("message.LinkedOkr.008","* 연결된 OKR을 해제해도 과제/보드멤버는 유지되며, 새로 추가되거나 삭제된 OKR의 멤버는 별도 관리해주세요.") }}</li>
          <li>{{ $i18nUtil.trans("message.LinkedOkr.009","* 일시정지 OKR은 보여지지 않습니다.") }}</li>
        </ul>

        <div class="btn-box">
          <div class="txt" v-if="modalInfo.type != 'OkrLink'">{{$i18nUtil.trans("message.LinkedOkr.010","과제를 수행할 멤버를 추가해주세요.")}}</div>
          <button
            type="button"
            class="btn-primary-small"
            @click="addOkrMember"
            v-if="modalInfo.type != 'OkrLink'"
          >
            {{ $i18nUtil.trans("title.AddOkrMemeber.001","연결된 OKR에서 멤버 추가") }}
          </button>
          <!-- <button
            type="button"
            class="btn-primary-small"
            @click="addMember"
            v-if="modalInfo.type != 'OkrLink'"
          >
            조직도에서 멤버 추가
          </button> -->
          <ul class="ref">
            <li>
              {{ $i18nUtil.trans("message.LinkedOkr.013","* 연결된 OKR의 하위 OKR 있으면, 하위 OKR 수행 멤버를 과제의 멤버로 추가할 수 있습니다.") }}
            </li>
          </ul>
        </div>
      </div>

      <footer class="modal-footer">
        <button type="button" class="btn_ty1" @click="handlerRegistClick">
          {{ $i18nUtil.trans("button.register","등록") }}
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import Datepicker from "vuejs-datepicker";
import AddOkrMember from "./AddOkrMember";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import EventBus from "@/js/eventbus/eventBus";
export default {
  components: {
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      projectOkrLinkList: [],
      okrMemberList: [],
      addOkrMemberParam: {},
      currentQrt: {
        qrtCd: "",
        qrtTopMsg: "",
        qrtTopMsgEn: null,
      },
      startDate: "",
      endDate: "",
      myForIndex: 0,
      targetForIndex: 0,
      qrtList: [],
      myOkrList: [],
      myKrList: [],
      targetOkrList: [],
      targetKrList: [],
      currentKr: {},
      toggleActive: false,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      isShowLayer: false,
    };
  },
  computed: {
    ...mapState("project", ["createProjectMemberList"]), // 추가시 등록될 멤버
  },
  created() {
    if (this.modalInfo.type == "OkrLink") {
      let body = document.querySelector("body");
      body.style.overflow = "hidden";
    }
    this.getQrtList();
    this.setCreateProjectMemberList([]);
    // EventBus.$off("addProjectMember");
    EventBus.$off("OkrLinkRegistEvent");
    // EventBus.$on("addProjectMember", () => {
    //   console.log("EventBus addProjectMember");
    //   this.$emit("close");
    // });
    EventBus.$on("OkrLinkRegistEvent", (param) => {
      console.log("EventBus OkrLinkRegistEvent");
      if (param == "confirm") {
        this.addOkrMember();
      } else {
        this.registOkrLink();
      }
    });
  },
  mounted() {
    if (this.modalInfo.type != "OkrLink") {
      this.getOkrMemberList();
    }
  },
  methods: {
    ...mapMutations("project", ["setCreateProjectMemberList"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    qrtChange(qrtCd, event) {
      this.currentQrt.qrtCd = qrtCd;
      this.currentQrt.qrtTopMsg = event.target.innerText;
      this.currentKr = {};

      this.getOkrList(qrtCd);
      this.getProjectOkrLink(qrtCd);
    },
    getQrtList() {
      this.showLoadingbar();
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getQrtList",
        method: "post",
        req: {
          qrtCd: this.currentQrt.qrtCd,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((data) => {
          if (!data.errorCode) {
            obj.qrtList = data.result;
            for (let i = 0; i < obj.qrtList.length; i++) {
              if (obj.qrtList[i].CURR_QRT_YN == 1) {
                obj.currentQrt.qrtCd = obj.qrtList[i].QRT_CD;
                obj.currentQrt.qrtTopMsg = obj.qrtList[i].QRT_TOP_MSG;
                obj.currentQrt.qrtTopMsgEn = obj.qrtList[i].QRT_TOP_MSG_EN;
                obj.getOkrList(obj.qrtList[i].QRT_CD);
                obj.getProjectOkrLink(obj.qrtList[i].QRT_CD);
                break;
              }
            }
          }
        })
        .catch((err) => {
          alert("getQrtList fail");
        });
    },
    getOkrList(qrtCode) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getOkrList",
        method: "post",
        req: {
          qrtCd: qrtCode,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((data) => {
          if (!data.errorCode) {
            console.log(data);
            const myOkr = data.result.myOkrList;
            const targetOkr = data.result.targetOkrList;
            if (myOkr) {
              obj.myOkrList = [];
              obj.myKrList = [];
              let krList = [];
              for (let i = 0; i < myOkr.length; i++) {
                if (myOkr[i].HOLD_YN == 0) {
                  if (myOkr[i].OKR_TYPE.indexOf("O") != -1) {
                    obj.myOkrList.push(myOkr[i]);
                  } else {
                    krList.push(myOkr[i]);
                  }
                }
              }
              for (let i = 0; i < obj.myOkrList.length; i++) {
                let krArray = [];
                for (let j = 0; j < krList.length; j++) {
                  if (obj.myOkrList[i].OKR_ID == krList[j].PARENT_OKR_ID) {
                    krArray.push(krList[j]);
                  }
                }
                obj.myKrList.push(krArray);
              }
              obj.myForIndex = obj.myOkrList.length;
            }
            if (targetOkr) {
              obj.targetOkrList = [];
              obj.targetKrList = [];
              let krList = [];
              for (let i = 0; i < targetOkr.length; i++) {
                if (targetOkr[i].HOLD_YN == 0) {
                  if (targetOkr[i].OKR_TYPE.indexOf("O") != -1) {
                    obj.targetOkrList.push(targetOkr[i]);
                  } else {
                    krList.push(targetOkr[i]);
                  }
                }
              }
              for (let i = 0; i < obj.targetOkrList.length; i++) {
                let krArray = [];
                for (let j = 0; j < krList.length; j++) {
                  if (obj.targetOkrList[i].OKR_ID == krList[j].PARENT_OKR_ID) {
                    krArray.push(krList[j]);
                  }
                }
                obj.targetKrList.push(krArray);
              }
            }
            obj.targetForIndex = obj.targetKrList.length;
          }
        })
        .catch((err) => {
          alert("getOkrList fail");
        });
    },
    addOkrMember() {
      if (this.currentKr.OKR_ID == null || this.currentKr.OKR_ID == undefined) {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice","알림"),
          width: "400px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AG051"),
          button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
          component: Dialog,
        };
        this.showModal(modalInfo);
      } else {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.AddOkrMemeber.001","연결된 OKR에서 멤버 추가"),
          width: "800px",
          obj: this.$modal,
          okrId: this.currentKr.OKR_ID.toString(),
          okrTitle: this.currentKr.OKR_TITLE,
          groupId: this.modalInfo.groupId,
          component: AddOkrMember,
        };

        this.showModal(modalInfo);
      }
    },
    handlerAddOkrMember() {
      const obj = this;
      let addCogroupUserList = [];
      this.createProjectMemberList.forEach(function (item, index, arr) {
        //console.log("item:", item);
        let jsonData = {};
        jsonData.userId = item.userId;
        jsonData.userGrade = "MEMBER";
        jsonData.userKbn = "01";
        addCogroupUserList.push(jsonData);
      });
      const reqData = {
        url: "/api/cogroup/cogroupUser/registCogroupUser",
        method: "post",
        params: {
          groupId: obj.modalInfo.groupId,
          addCogroupUserList: addCogroupUserList,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            let body = document.querySelector("body");
            body.style.removeProperty("overflow");
            obj.$emit("close");
            obj.setCreateProjectMemberList([]);
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[멤버추가 오류]");
        });
    },
    selectKr(krItem, event) {
      this.currentKr = krItem;
      if (
        $(".dl_layer.select_ty3.okr_linked").children("dt").hasClass("active")
      ) {
        $(".dl_layer.select_ty3.okr_linked")
          .children("dt")
          .removeClass("active");
      }
      this.setCreateProjectMemberList([]);
    },
    changeDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const days = date.getDate();
      const currentTime =
        year.toString() +
        (month > 9 ? month : "0" + month).toString() +
        (days > 9 ? days : "0" + days).toString();
      return currentTime;
    },

    registOkrLink(type) {
      const obj = this;
      let isRegist = false;

      this.projectOkrLinkList.forEach((item) => {
        if (
          obj.modalInfo.type == "OkrLink" &&
          obj.currentQrt.qrtCd == item.qrtCd &&
          obj.currentKr.OKR_ID == item.okrId
        ) {
          obj.toastInfo.message = obj.$i18nUtil.trans("message.LinkedOkr.015","이미 등록된 OKR입니다.");
          obj.showToast(obj.toastInfo);
          obj.$emit("close");
          isRegist = true;
        }
      });
      if (!isRegist) {
        const reqData = {
          url: "/api/cogroup/okr/setProjectOkrLink",
          method: "post",
          req: {
            projectId: this.modalInfo.projectId,
            okrTitle: this.currentKr.OKR_TITLE,
            parentOkrId: this.currentKr.PARENT_OKR_ID,
            okrId: this.currentKr.OKR_ID.toString(),
            okrType: this.currentKr.OKR_TYPE,
            catId: this.currentKr.CAT_ID.toString(),
            holdYn: this.currentKr.HOLD_YN.toString(),
            unitId: this.currentKr.UNIT_ID,
            levelCd: this.currentKr.LEVEL_CD.toString(),
            publicYn: this.modalInfo.publicYn,
            qrtCd: this.currentQrt.qrtCd,
            qrtTopMsg: this.currentQrt.qrtTopMsg,
            qrtTopMsgEn: this.currentQrt.qrtTopMsgEn,
            okrStdDate: this.currentKr.OKR_STD_DATE,
            okrEndDate: this.currentKr.OKR_END_DATE,
            // addCogroupUserList: this.createProjectMemberList,
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              obj.toastInfo.message = this.$i18nUtil.trans("TB048");
              obj.showToast(obj.toastInfo);
              EventBus.$emit("homeAddOkr");
              if (type == "OkrLink") {
                this.$emit("closeOkrLinkPopup");
                EventBus.$emit("closeOkrLinkPopup");
              }
              let body = document.querySelector("body");
              body.style.removeProperty("overflow");
              this.$emit("close");
            }
          })
          .catch((err) => {
            console.log("okr연결 실패");
          });

        if (this.createProjectMemberList.length > 0) {
          this.handlerAddOkrMember();
        }
      }
    },
    // addMember() {
    //   if (this.currentKr.OKR_ID == null || this.currentKr.OKR_ID == undefined) {
    //     console.log("LinkedOkr-addMember-noOkr");
    //     const modalInfo = {
    //       title: "알림",
    //       width: "400px",
    //       height: "166px",
    //       obj: this.$modal,
    //       contents: this.$i18nUtil.trans("AB039"),
    //       button: "확인",
    //       subButton: "취소",
    //       dialogType: "addProjectMember",
    //       component: Dialog,
    //     };
    //     this.showModal(modalInfo);
    //   } else {
    //     console.log("LinkedOkr-addMember-okr");
    //     // this.registOkrLink();
    //     this.$emit("close");
    //     const modalInfo = {
    //       title: "조직도",
    //       method: "post",
    //       width: "1050px",
    //       height: "800px",
    //       obj: this.$modal,
    //       //orgType: "SINGLE_USER",
    //       //orgType: "MULTI_USER",
    //       orgType: "MULTI_ORG",
    //       //orgType: "SINGLE_DEPT",
    //       //orgType: "MULTI_DEPT",
    //       //component: Organization,
    //       component: MultiOrg,
    //       url: "/api/org/getDeptList",
    //     };
    //     this.showModal(modalInfo);
    //   }
    // },
    handlerRegistClick() {
      if (this.currentKr.OKR_ID == null || this.currentKr.OKR_ID == undefined) {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice","알림"),
          width: "400px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AG051"),
          button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
          component: Dialog,
        };
        this.showModal(modalInfo);
        return;
      }
      if (this.modalInfo.type == "OkrLink") {
        this.registOkrLink("OkrLink");
        return;
      } else {
        if (
          this.okrMemberList.length == 0 ||
          this.createProjectMemberList.length > 0
        ) {
          this.registOkrLink();
          this.$router.replace(
            "/general/dashboard/" + this.modalInfo.projectId
          );
        } else {
          const modalInfo = {
            title: this.$i18nUtil.trans("title.dialog.notice","알림"),
            width: "400px",
            obj: this.$modal,
            contents: this.$i18nUtil.trans("AB075"),
            dialogType: "OkrRegist",
            button: this.$i18nUtil.trans("button.register","등록"),
            subButton: this.$i18nUtil.trans("title.dialog.add.member","멤버 추가"),
            projectId: this.modalInfo.projectId,
            component: Dialog,
          };
          this.showModal(modalInfo);
        }
      }
    },
    getOkrMemberList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getOkrUserList",
        method: "post",
        params: {
          okrId: this.currentKr.okrId,
          groupId: this.modalInfo.groupId,
          locale: this.$i18nUtil.getLanguage()
        },
      };

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.okrMemberList = res.result;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* okr 연결 목록 */
    getProjectOkrLink(qrtCd) {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getProjectOkrList",
        method: "post",
        params: {
          projectId: this.modalInfo.projectId,
          qrtCd: qrtCd,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (!res.errorCode) {
            obj.projectOkrLinkList = res.result.data;
          }
          obj.hideLoadingbar();
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    ChangeOkrType(type) {
      let resultType = "";
      const okrType = type.substring(0, 1);
      if (okrType == "M") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeM","개인");
      } else if (okrType == "U") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeU","유닛");
      } else if (okrType == "T") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeT","팀");
      } else if (okrType == "H") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeH","본부");
      } else {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeElse","회사");
      }
      return resultType;
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
  .mas030 .enCss {
      width: calc(100% - 200px);
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/LinkedOkr.vue